import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

interface SeoHeadProps {
  metaKey: string;
}

const SeoHead: React.FC<SeoHeadProps> = ({ metaKey }) => {
  const { t, i18n } = useTranslation();

  const title = t(`${metaKey}.title`, { defaultValue: 'SkTech' });
  const description = t(`${metaKey}.description`, { defaultValue: '' });
  const keywords = t(`${metaKey}.keywords`, { defaultValue: '' });

  return (
    <Helmet>
      <html lang={i18n.language} />
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
    </Helmet>
  );
};

export default SeoHead;
